import { createRouter, createWebHistory  } from 'vue-router';
import defaultRoutes from "@/router/default";
import checkToken from "@/router/middleware/checkToken";
import closeModals from "@/router/middleware/closeModals";
import hideError from "@/router/middleware/hideError";
import resetFooterCounter from "@/router/middleware/resetFooterCounter";
import Recipient from "@/views/pages/Recipient.vue";
import Configuration from "@/views/pages/Configuration.vue";
import Dashboard from "@/views/pages/Dashboard.vue";
import GuestTicketAction from "@/views/external/GuestTicketAction.vue";
import GuestAuthorization from "@/views/external/GuestAuthorization.vue";

const routes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    components: {
      default: Dashboard,
      LeftSidebar: () => import('@/components/Sidebar.vue'),
    },
    meta: {
      middleware: [hideError, checkToken, closeModals, resetFooterCounter],
    }
  },
  {
    path: '/recipient',
    name: 'Recipient',
    components: {
      default: Recipient,
      LeftSidebar: () => import('@/components/Sidebar.vue'),
    },
    meta: {
      middleware: [hideError, checkToken, closeModals, resetFooterCounter],
    }
  },
  {
    path: '/external',
    name: 'External',
    component: GuestTicketAction,
    meta: {
      middleware: [hideError, checkToken, closeModals, resetFooterCounter],
    }
  },
  {
    path: '/external/:id([0-9a-f]{8}[-]?[0-9a-f]{4}[-]?[0-9a-f]{4}[-]?[0-9a-f]{4}[-]?[0-9a-f]{12})',
    name: 'ExternalAuth',
    component: GuestAuthorization,
    meta: {
      middleware: [hideError, closeModals, resetFooterCounter],
    }
  },
  {
    path: '/config',
    name: 'Configuration',
    components: {
      default: Configuration,
      LeftSidebar: () => import('@/components/Sidebar.vue'),
    },
    meta: {
      middleware: [hideError, checkToken, closeModals, resetFooterCounter],
    }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...defaultRoutes,
    ...routes
  ],
})


/*--- MIDDLEWARE IMPLEMENTATION ---*/


function middlewarePipeline (context:any, middleware:any, index:any) {
  const nextMiddleware = middleware[index]

  if(!nextMiddleware){
    return context.next
  }

  return () => {
    const nextPipeline = middlewarePipeline(
        context, middleware, index + 1
    )

    nextMiddleware({ ...context, next: nextPipeline })

  }
}


router.beforeEach((to, from, next) => {

  /** Navigate to next if middleware is not applied */
  if (!to.meta.middleware) {
    return next()
  }

  const middleware:any = to.meta.middleware;
  const context = {
    to,
    from,
    next,
    //   store  | You can also pass store as an argument
  }

  return middleware[0]({
    ...context,
    next:middlewarePipeline(context, middleware,1)
  })
})

export default router;
